<template>
    <div>
        <el-row>
            <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                    <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                </el-tooltip>
            </el-col>
            <el-col :span="12">
                <h3><span v-show="!create">修改签章</span><span v-show="create">新增签章</span></h3>
            </el-col>
        </el-row>
        <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="票种选择" required prop="einvoiceTypeCode">
                            <el-select v-model="form.einvoiceTypeCode" placeholder="请选择">
                                <el-option v-for="item in einvoiceTypeOptions" :key="item.einvoiceTypeName" :label="item.einvoiceTypeName" :value="item.einvoiceTypeCode" :disabled="!create">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="财政监制章" required prop="supervisorSealCode">
                            <el-select v-model="form.supervisorSealCode" placeholder="请选择">
                                <el-option v-for="item in supervisorSealOptions" :key="item.mc" :label="item.mc" :value="item.dm">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="印章编号" required prop="invoicingSealId">
                            <el-input ref="ipt01" v-model="form.invoicingSealId" placeholder="请输入印章编号" maxlength="100"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="印章名称" required prop="invoicingSealName">
                            <el-input ref="ipt02" v-model="form.invoicingSealName" placeholder="请输入印章名称" maxlength="10"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="签章选择" prop="fileName">
                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    action="1"
                                    :limit="2"
                                    accept="image/jpeg,image/gif,image/png" 
                                    :multiple="false"
                                    :on-change="handleFileUpload"
                                    :on-remove="handleFileRmove"
                                    :on-preview="download"
                                    :file-list="this.fileList"
                                    :auto-upload="false">
                                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                                <span slot="tip" style="margin-left:5px; color:#F56C6C; font-size:8px;">（请上传图片格式文件，大小不能超过1M）</span>
                            </el-upload>
                            <el-link v-if="!create" :underline="false" @click="downloadHistory()"><i
                                    class="el-icon-document el-icon--right"></i> {{form.fileNameHistory}}
                            </el-link>
                            <el-button v-if="!create" size="mini" @click="downloadHistory()" type="text"
                                    style="float: right; height: 40px;"><i class="el-icon-circle-check" style="color: rgba(14,128,27,0.79)"></i> 下载
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity", "mode"],
        data() {
            var checkDate = (rule, value, callback) => {
                if (create && (this.form.fileBase64 == '' || this.form.fileBase64 == undefined)) {
                    callback(new Error("请上传文件"));
                } else {
                    callback(); 
                }
            };
            let create = !this.entity.einvoiceTypeCode
            let form = {
                agencyCode: this.entity.agencyCode,
                isValid: "Y",
                einvoiceTypeCode: this.entity.einvoiceTypeCode,
                fileName:""
            }
            let data = {
                fileList: [],
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                einvtypeCodeOptions: [],
                create,
                form,
                formRules: {
                    einvoiceTypeCode: [
                        { required: true, message: "请选择票种", trigger: "blur" }
                    ],
                    supervisorSealCode: [
                        { required: true, message: "请选择财政监制章",  trigger: "blur" }
                    ],
                    invoicingSealId: [
                        { required: true, message: "请输入印章编号", trigger: "blur" }
                    ],
                    invoicingSealName: [
                        { required: true,  message: "请输入印章名称", trigger: "blur" }
                    ],
                    fileName: [
                        { validator: checkDate,  trigger: "change" }
                    ]
                },
                einvoiceTypeOptions: [],
                supervisorSealOptions: []
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            download() {
                if (this.form.fileBase64 != '' || this.form.fileBase64 != undefined) {
                    this.downloadBase64(this.form.fileName, this.form.fileBase64)
                } else {
                    this.getBase64Online(result => {
                        this.downloadBase64(result.data.fileName, result.data.fileBase64)
                    })
                }
            },
            downloadBase64(fileName, base64) {
                let data_head = 'data:;base64,'
                let a = document.createElement('a')
                a.download = fileName
                a.href = data_head + base64
                document.querySelector("body").appendChild(a)
                a.click()
                document.querySelector("body").removeChild(a)
            },
            downloadHistory() {
                this.downloadBase64(this.form.fileNameHistory, this.form.fileBase64History)
            },
            handleFileUpload(file, fileList) {
                const isLt2M = file.size / 1024 / 1024 < 1
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 1MB!')
                    this.$refs.upload.clearFiles();
                    return false
                }
                console.log('handleFileUpload')
                this.form.fileName = file.name
                console.log(fileList.length)
                if(fileList.length > 1){
                    fileList.splice(0,1);
                }
                this.getBase64(file.raw).then(res => {
                    let arr = res.split(',')
                    this.form.fileBase64 = arr[1]
                    this.$refs['form'].validateField('fileName')
                }).catch(e=>{
                    console.log(e)
                })
            },
            handleFileRmove(file, fileList) {
                console.log('handleFileRmove')
                this.form.fileName = ""
                this.form.fileBase64 = ""
            },
            getBase64(file) {
                return new Promise(function (resolve, reject) {
                    let reader = new FileReader()
                    let imgResult = ""
                    reader.readAsDataURL(file)
                    reader.onload = function () {
                        imgResult = reader.result
                    }
                    reader.onerror = function (error) {
                        reject(error)
                    }
                    reader.onloadend = function () {
                        resolve(imgResult)
                    }
                })
            },
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit();
            }
        },
        created() {
            _kits = this.$kits()
            _kits.api.call(
                "GETCOLLECTION", {
                   "collectionId": "supervisorSealCollection"
                },
                result => {
                    if (result.returnCode == "0000") {
                        console.log(result.data);
                        this.supervisorSealOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call(
                "QUERYAGENCYEINVOICETYPECODE", {
                   "agencyCode": this.entity.agencyCode
                },
                result => {
                    if (result.returnCode == "0000") {
                        console.log(result.data);
                        this.einvoiceTypeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            if (!this.create) {
                _kits.api.call(
                    "QUERYAGENCYSEALBYID", {
                        agencyCode: this.entity.agencyCode,
                        einvoiceTypeCode: this.entity.einvoiceTypeCode
                    },
                    result => {
                        console.log(result);
                        if (result.returnCode == "0000") {
                            this.form = JSON.parse(JSON.stringify(result.data))
                        } else {
                            this.$message.error(result.returnMsg);
                        }
                    }
                );
            }
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "SAVEAGENCYSEAL" : "UPDATEAGENCYSEAL"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
        }
    }
</script>
